import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';

import { WalletEditComponent } from './wallet-edit.component';

@Injectable()
export class WalletEditDialog {
  readonly #dialog = inject(DialogService);

  open(wallet: WalletCard): DialogRef {
    return this.#dialog.open(WalletEditComponent, { wallet });
  }
}
